import React, { useState } from 'react'
import {
  useLocation,
  NavLink,
} from "react-router-dom"

export default ({label, url, local = true, theme = 'normal'}) => {
  if (!local) {
    return (
      <a href={url} target="_blank">
        <div className={`ecs_button ${theme}`}>
          {label} <span className="material-symbols-rounded text-xs">arrow_forward_ios</span>
        </div>
      </a>
    )
  }

  return (
    <NavLink to={url}>
      <div className={`ecs_button ${theme}`}>
        {label} <span className="material-symbols-rounded text-xs">arrow_forward_ios</span>
      </div>
    </NavLink>
  )
}